import { Component, Vue } from 'vue-property-decorator'
import { Feature } from '~/plugins/feature-flags'
import { WINNER_BLAST_TEST } from '~/plugins/feature-flags/variants'

@Component
export default class WinnerBlastFeature extends Vue {
  getWinnerBlastFeatureEnabled() {
    return this.$featureFlags?.isEnabled(Feature.WinnerBlast)
  }

  getWinnerBlastFeatureVariant() {
    return this.$featureFlags?.getVariant(Feature.WinnerBlast)?.name
  }

  getWinnerBlastFeatureVisible() {
    return (
      this.getWinnerBlastFeatureEnabled() &&
      this.getWinnerBlastFeatureVariant() === WINNER_BLAST_TEST
    )
  }
}
